module.exports = __webpack_public_path__ + "static/006091-2-d522b0f3fac5e7f01cb6d4f56d05c0ab.jpg";